import { render, staticRenderFns } from "./index.vue?vue&type=template&id=725bbd74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=725bbd74&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725bbd74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('725bbd74')) {
      api.createRecord('725bbd74', component.options)
    } else {
      api.reload('725bbd74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=725bbd74&scoped=true", function () {
      api.rerender('725bbd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/photo-gallery/index.vue"
export default component.exports